import { IApplicationState } from 'shared/types/redux';
import { ILandingState } from 'shared/types/features';

export const selectCalculatorErrors = (state: IApplicationState): ILandingState['calculatorErrors'] =>
  state.landing.calculatorErrors;
